import { render, staticRenderFns } from "./exam1.vue?vue&type=template&id=303771b4&scoped=true&"
import script from "./exam1.vue?vue&type=script&lang=js&"
export * from "./exam1.vue?vue&type=script&lang=js&"
import style0 from "./exam1.vue?vue&type=style&index=0&id=303771b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303771b4",
  null
  
)

export default component.exports